export enum ImageVerdict {
  Approved = "APPROVED",
  Rejected = "REJECTED",
  Review = "REVIEW",
  Secondary = "SECONDARY",
}
export class ModerationResults {
  moderationResults: {
    [key: string]: {
      present: boolean;
      confidence: number;
      note: string;
      code: string;
    };
  };
  faceDetections: {
    facesPresent: boolean;
    faceCount: number;
    containsChild: boolean;
    childConfidence: number;
    note: string;
  };
  personFeatures: {
    hairColor: string;
    hairStyle: string;
    eyeColor: string;
    skinTone: string;
    gender: string;
    glasses: boolean;
    facialHair: boolean;
    beardType: string;
    makeup: boolean;
    earrings: boolean;
    clothingType: string;
    clothingColor: string;
    hat: boolean;
    mask: boolean;
    bodyVisible: boolean;
    pose: string;
    expression: string;
    note: string;
  };
  qualityAssessment: {
    score: number;
    note: string;
  };
  verdict: string;
  verdictReason: string;
}
